import { NavLink } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";

const LINKS = [
  { to: "/check", label: "Check" },
  { to: "/loads", label: "Loads" },
  { to: "/logs/fuel", label: "Fuel log" },
  { to: "/logs/detention", label: "Detention" },
  { to: "/logs/maintenance", label: "Maintenance" },
  { to: "/money", label: "Money" },
  { to: "/board", label: "Board", fleetOnly: true },
  { to: "/settings", label: "Settings" },
] as const;

export function SideNav() {
  const me = useAuthStore((s) => s.me);
  const fleet = me?.org.type === "fleet" || me?.plan.planId === "fleet";
  return (
    <nav className="side-nav" aria-label="Side">
      {LINKS.filter((l) => !("fleetOnly" in l && l.fleetOnly) || fleet).map(
        (t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) =>
              `nav-link${isActive ? " active" : ""}`
            }
          >
            {t.label}
          </NavLink>
        ),
      )}
    </nav>
  );
}
